<template>
  <el-dialog
    :title="schedule.id ? 'Edit Schedule' : 'Create Schedule'"
    visible
    top="2vh"
    width="95%"
    :close-on-click-modal="false"
    :fullscreen="isFullscreen"
    @close="$emit('close')"
  >
    <el-tabs v-model="activeName">
      <el-tab-pane
        label="Schedule"
        name="first"
      >
        <ScheduleEditForm
          :schedule="schedule"
          @updatedSchedule="onUpdatedSchedule"
        />
      </el-tab-pane>
      <el-tab-pane
        label="Exceptions"
        name="second"
        :disabled="!schedule.id"
      >
        <ScheduleExceptionsEditForm
          v-if="schedule.id"
          :schedule-id="schedule.id"
        />
      </el-tab-pane>
      <el-tab-pane
        label="Template"
        name="third"
        :disabled="!schedule.id"
      >
        <div v-if="schedule.id && template">
          <PickupEditForm
            is-schedule-template
            :pickup.sync="template"
          />
          <el-button
            size="small"
            style="float: right;"
            type="primary"
            :loading="isLoadingTemplate"
            @click.native="saveTemplate"
          >
            Save Template
          </el-button>
        </div>
        <template v-else>
          Loading...
        </template>
      </el-tab-pane>
      <el-tab-pane
        label="Notes"
        name="fourth"
        :disabled="!schedule.id"
      >
        <ScheduleNotes
          v-if="schedule.id"
          :schedule="schedule"
        />
      </el-tab-pane>
    </el-tabs>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button
        @click.native="$emit('close')"
      >
        Cancel
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import ScheduleEditForm from '@/components/Application/Manage/SchedulePickup/ScheduleEditForm'
import ScheduleExceptionsEditForm from '@/components/Application/Manage/SchedulePickup/ScheduleExceptionsEditForm'
import PickupEditForm from '@/components/Application/CustomerService/Pickups/Pickup/EditForm'
import ScheduleNotes from '@/components/Application/Manage/SchedulePickup/ScheduleNotes'
export default {
  components: {
    ScheduleEditForm,
    ScheduleExceptionsEditForm,
    PickupEditForm,
    ScheduleNotes
  },
  props: {
    schedule: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isFullscreen: false,
      activeName: 'first',
      template: null,
      isLoadingTemplate: false
    }
  },
  created () {
    this.loadTemplate()
  },
  methods: {
    loadTemplate () {
      if (this.schedule.id && this.schedule.template && this.schedule.template.id) {
        this.isLoadingTemplate = true
        this.$sdk.scheduledpickup_template.read(this.schedule.template.id, builder => {
          builder.context = { resource: 'scheduledpickup', id: this.schedule.id }
          builder.include = ['account.carrier_settings.carrier', 'account.carrier_service_settings.carrier_service.carrier', 'profile', 'carrier', 'carrier_service', 'sender', 'receiver', 'consignments.items', 'items.type', 'customer_time_zone', 'team.shipper_setting.address']
        }).then(res => {
          this.template = res
        }).finally(() => { this.isLoadingTemplate = false })
      } else if (this.schedule.id && !this.schedule.template) {
        this.setNewTemplate()
      }
    },
    saveTemplate () {
      this.isLoadingTemplate = true
      if (this.schedule.id && !this.schedule.template) { // Create Template
        this.template.create(builder => {
          builder.context = { resource: 'scheduledpickup', id: this.schedule.id }
          builder.include = ['account.carrier_settings.carrier', 'account.carrier_service_settings.carrier_service.carrier', 'profile', 'carrier', 'carrier_service', 'sender', 'receiver', 'consignments.items', 'items.type', 'customer_time_zone', 'team.shipper_setting.address']
        })
          .then(() => { this.$message.success('Successfully saved') })
          .finally(() => {
            this.isLoadingTemplate = false
            this.$emit('reload')
          })
      } else { // Update existing template
        this.template.update(builder => {
          builder.context = { resource: 'scheduledpickup', id: this.schedule.id }
          builder.include = ['account.carrier_settings.carrier', 'account.carrier_service_settings.carrier_service.carrier', 'profile', 'carrier', 'carrier_service', 'sender', 'receiver', 'consignments.items', 'items.type', 'customer_time_zone', 'team.shipper_setting.address']
        })
          .then(() => { this.$message.success('Successfully saved') })
          .finally(() => {
            this.isLoadingTemplate = false
            this.$emit('reload')
          })
      }
    },
    setNewTemplate () {
      this.template = new this.$sdk.scheduledpickup_template()
      this.template.type = 'scheduled'
      this.template.sender = new this.$sdk.address()
      this.template.receiver = new this.$sdk.address()
      this.template.collection_name = 'DESPATCH'
      this.template.items = [new this.$sdk.pickup_item()]
    },
    onUpdatedSchedule (schedule) {
      this.$emit('updatedSchedule', schedule.clone())
      if (!this.schedule.template) {
        this.setNewTemplate()
      }
    }
  }
}
</script>
